<template>
  <div v-if="isManager">
    {{ getWeekDay }} - {{ today | dateFormat }} - {{ nowTime }}
  </div>
  <CCard v-else>
    <CCardHeader>
      تقویم و ساعت
      <!-- <CBadge color="success" class="float-right">Success</CBadge> -->
    </CCardHeader>
    <CCardBody>
      <div class="d-flex justify-content-between h-100">
        <div class="gray-800">
          <h5>{{ getWeekDay }}، {{ today | dateFormat }}</h5>
          <h5>{{ today | dateDigitFormat }}</h5>
        </div>
        <div class="time-text align-self-end gray-800">
          {{ nowTime }}
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  props: {
    isManager: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nowTime: 0,
      week: [
        "یکشنبه",
        "دوشنبه",
        "سه شنبه",
        "چهارشنبه",
        "پنج شنبه",
        "جمعه",
        "شنبه",
      ],
      today: "",
    };
  },
  computed: {
    getWeekDay() {
      const now = new Date();
      const weekDay = this.week[now.getUTCDay()];
      return weekDay;
    },
  },
  created() {
    this.getTimeNow();
    this.getNow();
  },
  methods: {
    getTimeNow() {
      setInterval(() => {
        const now = new Date();
        this.nowTime =
          this.checkSingleDigit(now.getHours()) +
          ":" +
          this.checkSingleDigit(now.getMinutes());
      }, 1000);
    },
    getNow() {
      const now = new Date();
      this.today =
        now.getMonth() + 1 + "/" + now.getDate() + "/" + now.getFullYear();
      return this.today;
    },
    checkSingleDigit(digit) {
      return ("0" + digit).slice(-2);
    },
  },
};
</script>

<style lang="scss" scoped>
.time-text {
  font-size: 60px;
}
</style>
